import { AccountManagement } from "@/interfaces/accountManagement";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./CreditCardsList.template.vue";

@Component({
  mixins: [Template]
})
export default class CreditCardsListComponent extends Vue {
  @Prop({ default: () => [] })
  public cards!: AccountManagement.CreditCard[];
  @Prop({ default: null })
  public value!: AccountManagement.CreditCard;
  @Prop({ required: true })
  public actions!: { canAdd: boolean; canEdit: boolean; canDelete: boolean };
  @Prop({ default: false })
  public loading!: boolean;

  public editCard() {
    this.$emit("editCard", this.selected);
  }

  public newCard() {
    this.$emit("newCard");
  }

  public goToEdit(card: AccountManagement.CreditCard) {
    this.editCard();
    this.$router.push({
      name: "edit-credit-card",
      params: { id: String(card.id), card: JSON.stringify(card) }
    });
  }

  public goToNew() {
    this.newCard();
    this.$router.push({
      name: "new-credit-card"
    });
  }

  public removeCard(card: AccountManagement.CreditCard) {
    this.$emit("cardDelete", card);
  }

  get selected() {
    return this.value;
  }

  set selected(card: AccountManagement.CreditCard) {
    this.$emit("input", card || null);
  }
}
